export const lowestNumberHelpers = (number: number[]) => {
  return Math.min(...number)
}
